import FeaturesSet from './utils/features'

const store = {
    state: {
        actVer: null,
        readOnly: false,
        selectedID: 0,
        copyNode: false,
        nodeForPaste: null,
        prodForPut: null,
        curFolderName: null,
        curActTimestamp: 0,
        curFolderInfo: null,
        curUserRole: null,
        curUser: null,
        curFolderIsSubdomain: null,
        fileForPaste: null,
        fileForLink: null,
        propNode: null,
        subdomainsInfo: null,
        projType: null,
        blockChainReady: false,
        isDDIProject: false,
        userMsgReady: false,
      //  modelEnums: {},
        propEnums: {},
        stompClient: null,
        urlData: {},
        renameNodeAttr: {},
        curRenameNodeAttr: null,
        initInfo: {},
        isMobile: false,
        sso_id: null,
        projLock: null,
        projAutoVer: true,
        notifications: [],
        selectedNodes: [],
        selectedFiles: [],
        selectedCopy: false,
        selectedCut: false,
        useNewGUI: ( localStorage.getItem("useNewGUI") === 'true' )
    },
    getSelMsg()
    {
        let num = this.state.selectedFiles.length + this.state.selectedNodes.length;
        let msg = 'selected ';
        if( this.state.selectedCopy )
            msg = 'copied ';
        else if( this.state.selectedCut )
            msg = 'cutted ';

        msg += num + ' item';
        if( num > 1 )
            msg += 's';

        return msg;
    },
    hasSelected()
    {
   //     console.log( this.state.selectedNodes );
        return ( this.state.selectedFiles && this.state.selectedFiles.length > 0 ) 
            || ( this.state.selectedNodes && this.state.selectedNodes.length > 0 );
    },
    toggleSelectedFile( fID, state )
    {
        for( let i = 0; i < this.state.selectedFiles.length; i++ )
        {
            if( this.state.selectedFiles[ i ] === fID )
            {
                this.state.selectedFiles.splice( i, 1 );
                return;
            }
        }
        this.state.selectedFiles.push( fID );
    },
    toggleSelectedNode( nID )
    {
        for( let i = 0; i < this.state.selectedNodes.length; i++ )
        {
            if( this.state.selectedNodes[ i ] === nID )
            {
                this.state.selectedNodes.splice( i, 1 );
                return;
            }
        }
        this.state.selectedNodes.push( nID );
    },
    clearSelectedFiles()
    {
        this.state.selectedFiles = [];
    },
    clearSelectedNodes()
    {
        this.state.selectedNodes = [];
    },
    setProjLock( info )
    {
        this.state.projLock = info;
    },
    clearProjLock()
    {
        this.state.projLock = null;
    },
    setUseNewGUI()
    {
        localStorage.setItem("useNewGUI", true);
        this.state.useNewGUI = true;
    },
    clearUseNewGUI()
    {
        localStorage.setItem("useNewGUI", false);
        this.state.useNewGUI = false;
    },
    procProjNotifications( proj, nList )
    {
        if( !nList || !nList.length )
            return;
        
        nList.forEach( n =>
        {
           this.procNotification( proj, n );
        });
    },
    procNotificationPrev( proj, task )
    {
       // console.log( task );
        let addIt = false;
        for( let i = 0; i < task.action.targets.length; i++ )
        {
            let trg = task.action.targets[ i ];
            if( 'USER' === trg.target_type && this.state.curUser === trg.name )
            {
                //task.open = false;
                addIt = true;
                break;
            }
        }
        
        if( addIt )
        {
            task.event.prms = {};
            for( let j = 0; j < task.event.parameters.length; j++ )
            {
                let attr = task.event.parameters[ j ];
                task.event.prms[ attr.name ] = attr;     
            }
            if( "Broadcast_message" === task.event.name )
            {
                if( this.state.curUser !== task.event.user )
                {
                    addIt = false;
                    let attr = task.event.prms.Msg_user;
                    if( attr )
                    {
                        let users = attr.val.split( "," );
                        addIt = users.includes( this.state.curUser );
                    }
                }
            }
            for( let i = 0; i < this.state.notifications.length; i++ )
            {
                if( task.id === this.state.notifications[ i ].noti.id )
                {
                    addIt = false;
                    break;
                }
            }
        }
        
        if( addIt )
        {
            for( let i = 0; task.done_for && i < task.done_for.length; i++ )
            {
                if( task.done_for[ i ].target_type === 'USER' && task.done_for[ i ].name === this.state.curUser )
                {
                    task.viewed = true;
                    break;
                }
            }
            this.state.notifications.push( { proj: { in_project: proj }, noti: task } );
        }
    },
    procNotification( proj, task )
    {
       // console.log( task );
        let isMsgUser = false;
        let isTrgUser = false;
        
        task.event.prms = {};
        for( let j = 0; j < task.event.parameters.length; j++ )
        {
            let attr = task.event.parameters[ j ];
            task.event.prms[ attr.name ] = attr;     
        }
            
        if( "Broadcast_message" === task.event.name )
        {
            isMsgUser = this.state.curUser === task.event.user;
            if( !isMsgUser )
            {
                let attr = task.event.prms.Msg_user;
                if( attr )
                {
                    let users = attr.val.split( "," );
                    isMsgUser = users.includes( this.state.curUser );
                }
            }
        }
        
        for( let i = 0; i < task.target_for.length; i++ )
        {
            let trg = task.target_for[ i ];
            if( this.state.curUser === trg.name )
            {
                isTrgUser = true;
                break;
            }
        }
        
        if( isTrgUser || isMsgUser )
        {
            for( let i = 0; i < this.state.notifications.length; i++ )
            {
                if( task.id === this.state.notifications[ i ].noti.id )
                    return;
            }
            
            task.viewed = isMsgUser && !isTrgUser;
            
            this.state.notifications.push( { proj: { in_project: proj }, noti: task } );
        }
    },
    setNotifications( vals )
    {
        this.state.notifications = vals || [];
    },
    setProjAutoVer( info )
    {
        this.state.projAutoVer = info.autoVersioning;
    },
    setBlockChainReady( val )
    {
        this.state.blockChainReady = val;
    },
    setDDIProject( val )
    {
        this.state.isDDIProject = val;
    },
    setUserMsgReady( val )
    {
        this.state.userMsgReady = val;
    },
    isAdmin()
    {
        return ( this.state.curUserRole === 'urn:rdl:epm-std:project_manager'
              || this.state.curUserRole === 'urn:rdl:epm-std:project_admin' );
    },
    clearType( type )
    {
        if( !type )
            return type;
        
        if( typeof type !== 'string' )
            return type;

        let parts = type.split( ',' );
        let rez = [];
        parts.forEach( ( p ) =>
        {
            let t = p.split( ':' );
            if( t[ t.length - 1 ] !== '' )
                t = t[ t.length - 1 ];
            else
                t = t[ t.length - 2 ] + ':';
            t = t.split( '#' );
            rez.push( t[ 0 ] );
        });
        
        return rez.join( ', ' );
    },
    checkPlatform()
    {
        let check = false;
       (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator['userAgent']||navigator['vendor']||window['opera']);

        this.state.isMobile = check;
   //     console.log( 'isMobile = ' + check );
    },
    clearInitInfo()
    {
        this.state.initInfo = {};
    },
    setInitInfo( info )
    {
        this.state.initInfo = info;
    },
    setCurRenameNodeAttr( val )
    {
        this.state.curRenameNodeAttr = val;        
//        let attr = this.state.renameNodeAttr[ val ];
//        if( attr )
//            this.state.curRenameNodeAttr = attr;
    },    
    clearCurRenameNodeAttr()
    {
        this.state.curRenameNodeAttr = null;
    },    
    addRenameNodeAttr( nodeID, attr )
    {
        this.state.renameNodeAttr[ nodeID ] = attr;        
    },    
    clearRenameNodeInfo()
    {
        this.state.renameNodeAttr = {};
    },    
    setURLData( info )
    {
        this.state.urlData = info;
    },
    setProjType( info )
    {
        if( !info )
            this.state.projType = null;        
        else
            this.state.projType = info.is_bkd_template_project ? 'BkdTmpl' : info.is_template_project ? 'Tmpl' : 'Proj';        
    },
    setActTimestamp()
    {
        this.state.curActTimestamp = Date.now();
        return this.state.curActTimestamp;
    },
    clearActTimestamp()
    {
        this.state.curActTimestamp = 0;
    },
    clearStompClient()
    {
        if( this.state.stompClient )
            this.state.stompClient.deactivate();
        
        this.state.stompClient = null;
    },
    setStompClient( data )
    {
        this.state.stompClient = data;
    },
    setSubdomainInfo( data )
    {
        this.state.subdomainsInfo = data;
    },
    clearSubdomainInfo()
    {
        this.state.subdomainsInfo = null;
    },
    setPropEnums( data )
    {
        this.state.propEnums = {};
        var nodeTypes = this.state.modelEnums.nodeTypesList;
        if( data && data.length === ( nodeTypes.length + 2 ) )
        {
            this.state.propEnums.fileProps = data[ 0 ];
            for( var i = 0; i < nodeTypes.length; i++ )
            {
                this.state.propEnums[ nodeTypes[ i ].val ] = [];
//                data[ 1 ].forEach( ( info ) =>
//                {
//                    this.state.propEnums[ nodeTypes[ i ].val ].push( info );
//                });
                this.state.propEnums[ nodeTypes[ i ].val ].push( { urn: 'urn:rdl:epm-std:Quantity', units: [ 'urn:plcs:rdl:missing-std:Count' ] } );
                data[ i + 2 ].forEach( ( info ) =>
                {
                    this.state.propEnums[ nodeTypes[ i ].val ].push( info );
                });
            }
        }
    },
//    setModelEnums( data )
//    {
//        this.state.modelEnums = data;
//    },
    setSsoId( sso_id )
    {
        this.state.sso_id = sso_id;
    },
    clearSsoId()
    {
        this.state.sso_id = null;
    },
    setPropNode( node )
    {
        this.state.propNode = node;
    },
    clearPropNode()
    {
        this.state.propNode = null;
    },
    setCurFolderName( name, is_sub_root, is_sub_part )
    {
        this.state.curFolderName = name;
        this.state.curFolderIsSubdomain = is_sub_root ? 'root' : is_sub_part ? 'part' : null;
    },
    setCurFolderInfo( folder )
    {
        this.state.curFolderInfo = folder;
        this.state.curFolderName = folder.name;

        if( this.clearType( folder.element_type ) === 'EPTI' )
        {
            for( let i = 0; i < folder.properties.length; i++ )
            {
                let prop = folder.properties[ i ];
                if( this.clearType( prop.name ) === 'HCNT' )
                {
                    this.state.curFolderName = ( prop.val + ' ' + folder.description );
                    break;
                }
            }
        }
        
        if( folder.version_id )
            this.state.curFolderName += ' (ver.' + folder.version_id + ')';
        this.state.curFolderIsSubdomain = ( folder.is_root_of_subdomain > 0 ) ? 'root' : ( folder.is_part_of_subdomain > 0 ) ? 'part' : null;
    },
    clearCurFolderInfo()
    {
        this.state.curFolderInfo = null;
        this.state.curFolderName = null;
        this.state.curFolderIsSubdomain = null;
    },
    setCurUserRole( role )
    {
        this.state.curUserRole = role;
        FeaturesSet.setRoles([role]);
    },
    clearCurUserRole()
    {
        this.state.curUserRole = null;
    },
    setCurUser( user )
    {
        this.state.curUser = user;
    },
    clearCurUser()
    {
        this.state.curUser = null;
    },
    setActVer( ver )
    {
        this.state.actVer = ver;
        this.state.readOnly = true;
    },
    clearActVer()
    {
        this.state.actVer = null;
        this.state.readOnly = false;
    },
    setSelectedID( newID ) 
    {
        this.state.selectedID = newID;
    },
    setProdForPut( prod )
    {
        this.state.prodForPut = prod;
    },
    clearProdForPut()
    {
        this.state.prodForPut = null;
    },
    setNodeForPaste( node, forCopy ) 
    {
        this.state.nodeForPaste = node;
        this.state.fileForPaste = null;
        this.state.fileForLink = null;
        this.state.copyNode = forCopy;
    },
    clearNodeForPaste() 
    {
        this.state.nodeForPaste = null;
        this.state.copyNode = false;
    },
    setFileForPaste( file ) 
    {
        this.state.fileForPaste = file;
        this.state.nodeForPaste = null;
        this.state.fileForLink = null;
    },
    clearFileForPaste() 
    {
        this.state.fileForPaste = null;
    },
    setFileForLink( file ) 
    {
        this.state.fileForLink = file;
        this.state.nodeForPaste = null;
        this.state.fileForPaste = null;
    },
    clearFileForLink() 
    {
        this.state.fileForLink = null;
    }
};

export default store